import React, { useState, useEffect } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core'
import {
  getAreaProductionAndLoss,
  getFertilizersTypes,
} from '../../../../../services/Elegibilidad/get'
import { UpdateUsedFertilizers } from '../../../../../services/Elegibilidad/put'
import swal from 'sweetalert'
import NumberFormat from 'react-number-format'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { InsertUsedFertilizers } from '../../../../../services/Elegibilidad/create'
import ReactTooltip from 'react-tooltip'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

export const Modal398 = ({
  open,
  setOpen,
  body,
  setBody,
  getDataTable,
  idElegibilityForm,
}) => {
  const [FertilizersTypes, setFertilizersTypes] = useState([])
  const [areaData, setAreaData] = useState([])
  const [SubProjectHectares, setSubProjectHectares] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorName, setErrorName] = useState(false)
  const [errorUnidad, setErrorUnidad] = useState(false)

  const {
    IdUsedFertilizer,
    IdProductionAndLosseByClimate,
    ProductionArea,
    IdFertilizerType,
    FertilizerDetail,
    TradeName,
    QuantityUsedUnit,
    QuantityUsedArea,
    Area,
  } = body

  const GeneralDataSchema = Yup.object().shape({
    Area: Yup.string().required('Este campo es obligatorio'),
    ProductionArea: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .max(
        SubProjectHectares,
        'Unidad de área de producción no debe ser mayor a la cantidad ingresada en Hectáreas que forman parte del subproyecto ',
      ),
    TradeName: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-(),./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(50, 'Máximo 50 caracteres')
      .typeError('Este campo es obligatorio'),

    QuantityUsedUnit: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-(),./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(50, 'Máximo 50 caracteres')
      .typeError('Este campo es obligatorio'),
    QuantityUsedArea: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),

    IdFertilizerType: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    FertilizerDetail: Yup.string()
      .when('IdFertilizerType', {
        is: (IdFertilizerType) => IdFertilizerType === 1,
        then: Yup.string().required('Este campo es obligatorio'),
      })
      .typeError('Este campo es obligatorio'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdElegibilityAnswer: idElegibilityForm,
      IdProductionAndLosseByClimate: IdProductionAndLosseByClimate,
      IdUsedFertilizer: IdUsedFertilizer,
      ProductionArea: ProductionArea,
      IdFertilizerType: IdFertilizerType,
      FertilizerDetail: FertilizerDetail !== null ? FertilizerDetail : '',
      TradeName: TradeName,
      QuantityUsedUnit: QuantityUsedUnit,
      QuantityUsedArea: QuantityUsedArea,
      Area: Area,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: () => {
      handleGuardar(formik.values)
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const getListFertilizersTypes = async () => {
    try {
      const response = await getFertilizersTypes()
      setFertilizersTypes(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  const getAreaProduction = async () => {
    try {
      const response = await getAreaProductionAndLoss(idElegibilityForm)
      if (response.Success) {
        setAreaData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (open) {
      getListFertilizersTypes()
      getAreaProduction()
    }
  }, [open])

  useEffect(() => {
    if (Object.keys(body).length !== 0 && areaData !== []) {
      const resultArea = areaData.filter(
        (obj) => obj.CategoryProduct === formik.values.Area,
      )
      setSubProjectHectares(resultArea[0]?.SubProjectHectares)
    }
  }, [formik.values.Area, areaData])

  const handleGuardar = async (values) => {
    setLoading(true)
    let response
    if (Object.keys(body).length !== 0) {
      response = await UpdateUsedFertilizers(values)
    } else response = await InsertUsedFertilizers(values)

    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getDataTable()
      handleClose()
      setLoading(false)
    }
  }

  const handleClose = () => {
    setOpen(false)
    setBody({})
    setSubProjectHectares('')
    formik.resetForm()
    setErrorName(false)
    setErrorUnidad(false)
  }
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos de fertilizantes y pesticidas</h1>
          </div>
          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Rubro / Producto</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    value={formik.values.Area}
                    onChange={(e) => {
                      formik.setFieldValue('Area', e.target.value)
                      const resultArea = areaData.filter(
                        (obj) => obj.CategoryProduct === e.target.value,
                      )
                      setSubProjectHectares(resultArea[0].SubProjectHectares)
                    }}
                    error={formik.errors.Area}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                    {areaData &&
                      areaData.map((item, key) => (
                        <MenuItem key={key} value={item.CategoryProduct}>
                          {item.CategoryProduct}
                        </MenuItem>
                      ))}
                  </Select>

                  {formik.errors.Area ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.Area}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch',
                }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Unidad de área de producción (Ha)
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareas"
                          name="cantHectareas"
                          customInput={TextField}
                          allowLeadingZeros={false}
                          thousandSeparator={true}
                          value={formik.values.ProductionArea}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'ProductionArea',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          isNumericString={true}
                          inputProps={{ maxLength: 10 }}
                          error={formik.errors.ProductionArea}
                          fixedDecimalScale={true}
                          decimalScale={2}
                        />

                        {formik.errors.ProductionArea ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.ProductionArea}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Tipo de fertilizante / pesticida
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <Select
                          id="IdProject"
                          name="IdProject"
                          variant="outlined"
                          displayEmpty={true}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'IdFertilizerType',
                              e.target.value,
                            )

                            if (e.target.value === 1) {
                              formik.setFieldValue('FertilizerDetail', '')
                            }
                          }}
                          value={formik.values.IdFertilizerType}
                          error={formik.errors.IdFertilizerType}
                          renderValue={
                            formik.values.IdFertilizerType !== null
                              ? undefined
                              : () => 'Seleccione una opción'
                          }
                        >
                          <MenuItem disabled value="">
                            Seleccione una opción
                          </MenuItem>
                          {FertilizersTypes &&
                            FertilizersTypes.map((item, key) => (
                              <MenuItem key={key} value={item.IdFertilizerType}>
                                {item.Description}
                              </MenuItem>
                            ))}
                        </Select>
                        {formik.errors.IdFertilizerType ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.IdFertilizerType}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {formik.values.IdFertilizerType === 1 ? (
                <Grid container>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Detalle</label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <TextField
                        id="MiPymeCountry"
                        name="MiPymeCountry"
                        type="text"
                        variant="outlined"
                        sx={{ width: 220 }}
                        value={formik.values.FertilizerDetail}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'FertilizerDetail',
                            e.target.value,
                          )
                        }}
                        error={formik.errors.FertilizerDetail}
                      />
                      {formik.errors.FertilizerDetail ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.FertilizerDetail}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
              ) : null}
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Nombre comercial</label>
                <a
                  data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    sx={{ width: 220 }}
                    value={formik.values.TradeName}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setErrorName(false)

                        formik.setFieldValue('TradeName', e.target.value)
                      } else {
                        setErrorName(true)
                      }
                    }}
                    inputProps={{
                      maxLength: 50,
                    }}
                    error={formik.errors.TradeName}
                  />
                  {errorName ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.TradeName ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.TradeName}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ textDecoration: 'underline ', marginTop: '5px' }}
              >
                <label className="responsiveLabel">
                  Cantidad utilizada por área de producción
                </label>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch',
                }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Unidad</label>
                      <a
                        data-tip="Se refiere a la unidad de medida de la producción (Quintales, toneladas, etc.) <br/>  Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                        data-for="infoCurrencyPop"
                        style={{ cursor: 'pointer' }}
                      >
                        <ErrorOutlineIcon fontSize="small" />
                        <ReactTooltip
                          id="infoCurrencyPop"
                          effect="solid"
                          multiline={true}
                          type="dark"
                        />
                      </a>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <TextField
                          id="MiPymeCountry"
                          name="MiPymeCountry"
                          type="text"
                          variant="outlined"
                          sx={{ width: 220 }}
                          value={formik.values.QuantityUsedUnit}
                          onChange={(e) => {
                            if (
                              e.target.value.match(
                                /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                              ) ||
                              e.target.value === ''
                            ) {
                              setErrorUnidad(false)
                              formik.setFieldValue(
                                'QuantityUsedUnit',
                                e.target.value,
                              )
                            } else {
                              setErrorUnidad(true)
                            }
                          }}
                          inputProps={{
                            maxLength: 30,
                          }}
                          error={formik.errors.QuantityUsedUnit}
                        />
                        {errorUnidad ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            Caracteres especiales no aceptados
                          </div>
                        ) : null}
                        {formik.errors.QuantityUsedUnit ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.QuantityUsedUnit}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Cantidad</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareas"
                          name="cantHectareas"
                          customInput={TextField}
                          thousandSeparator={true}
                          allowLeadingZeros={false}
                          value={formik.values.QuantityUsedArea}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'QuantityUsedArea',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          inputProps={{ maxLength: 10 }}
                          decimalScale={2}
                          fixedDecimalScale
                          error={formik.errors.QuantityUsedArea}
                        />
                        {formik.errors.QuantityUsedArea ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.QuantityUsedArea}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  disabled={loading}
                  onClick={validateFormStatus}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
